/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('DinghyEventBoardDeleteController', DinghyEventBoardDeleteController);

    DinghyEventBoardDeleteController.$inject = ['$uibModalInstance', 'entity', 'DinghyEventBoard'];

    function DinghyEventBoardDeleteController($uibModalInstance, entity, DinghyEventBoard) {
        var vm = this;

        vm.dinghyEvent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DinghyEventBoard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
